import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import CampingNearUs from "@/pages/CampingNearUs";

export const Route = createFileRoute("/camping-in-wilmington-north-carolina")({
  head: () => pageHead({
    title: 'Camping Near Wilmington NC',
    description: 'The best campgrounds and RV parks near Wilmington, NC — local camping guide from Rex & Sons RVs in Castle Hayne.',
    path: '/camping-in-wilmington-north-carolina',
  }),
  component: CampingNearUs,
});
